/**
 * Shared uniqueness service (TypeScript side).
 * Behaviour-identical to backend/utils/uniqueness.py — same catalog
 * (validation/uniqueness.json, synced into _generated/) and the same strong
 * normalization. Backend (DB) is authoritative; this provides an instant
 * in-memory pre-check against an already-loaded list.
 */
import catalog from './_generated/uniqueness.json';
export interface UniqEntry { code: number; table: string; field: string; feField: string; scope: string; mode: string; }
const CAT: Record<number, UniqEntry> = {};
(catalog as UniqEntry[]).forEach((e) => { CAT[e.code] = e; });

export function normalizeUnique(value: any, mode: string): string {
  const s = value == null ? '' : String(value);
  return mode === 'name' ? s.replace(/\s+/g, '').toLowerCase() : s.trim().toUpperCase();
}
/** Instant in-memory pre-check against the already-loaded list. */
export function isUniqueLocal(code: number, value: any, items: any[], excludeId?: any): boolean {
  const e = CAT[code]; if (!e) return true;
  if (value == null || String(value).trim() === '') return true;
  const target = normalizeUnique(value, e.mode);
  return !items.some((it) =>
    it && (it.is_active === undefined || it.is_active !== -1) &&
    (excludeId === undefined || it.id !== excludeId) &&
    normalizeUnique(it[e.feField], e.mode) === target);
}
